import Axios from 'axios'
import server from 'util/Server'
import { RecursoCreateRequest, ActualizarRecursoRequest } from '../interfaces/ConfiguracionRecursos.interfaces'
import { getSelectEDS } from 'app/vistas/Reportes/servicios/serviciosSelect'
import { getRegionalService } from 'services/selectServices/services'
import { getEmpresas } from 'services/Importadores/services'
import { getRegionales } from 'components/filtros/FiltrosEds/servicios'

export const GetListadoRecursos = (empresaId?: number | string) =>
    Axios.get(`${server.host!}8014/api/v1/configuracion-recursos/listado`, {
        params: empresaId ? { empresa_id: empresaId } : undefined,
        headers: { Authorization: server.obtenerToken() },
    })

export const GetDetalleRecurso = (recursoId: number) =>
    Axios.get(`${server.host!}8014/api/v1/configuracion-recursos/detalle`, {
        params: { recurso_id: recursoId },
        headers: { Authorization: server.obtenerToken() },
    })

export const CrearRecurso = ({ empresa_ids, tipo_id, estado_id, archivos }: RecursoCreateRequest) => {
    const formData = new FormData()

    empresa_ids.forEach((empresaId) => formData.append('empresa_ids', String(empresaId)))
    formData.append('tipo_id', String(tipo_id))
    if (estado_id !== undefined) formData.append('estado_id', String(estado_id))
    archivos.forEach(({ archivo, nombre, descripcion }) => {
        formData.append('archivos', archivo)
        formData.append('nombres', nombre)
        formData.append('descripciones', descripcion ?? '')
    })

    return Axios.post(`${server.host!}8014/api/v1/configuracion-recursos/crear`, formData, {
        headers: {
            Authorization: server.obtenerToken(),
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const EditarRecurso = ({
    id,
    tipo_id,
    nombre,
    descripcion,
    orden,
    url,
    estado_id,
    archivo,
}: ActualizarRecursoRequest) => {
    const formData = new FormData()

    formData.append('id', String(id))
    formData.append('tipo_id', String(tipo_id))
    formData.append('nombre', nombre)
    formData.append('descripcion', descripcion ?? '')
    if (orden !== undefined) formData.append('orden', String(orden))
    formData.append('url', url ?? '')
    formData.append('estado_id', String(estado_id))
    if (archivo) formData.append('archivo', archivo)

    return Axios.put(`${server.host!}8014/api/v1/configuracion-recursos/editar`, formData, {
        headers: {
            Authorization: server.obtenerToken(),
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const CambiarEstadoRecurso = (payload: { recurso_id: number; estado_id: number }) =>
    Axios.post(`${server.host!}8014/api/v1/configuracion-recursos/estado`, payload, {
        headers: { Authorization: server.obtenerToken() },
    })

export const GetTiposRecurso = () =>
    Axios.get(`${server.host!}8014/api/v1/configuracion-recursos/tipos`, {
        headers: { Authorization: server.obtenerToken() },
    })

export const getEdsByUserLogged = (empresas: string) => getEmpresas(empresas)

export const getRegionalesByNegocio = (negocio_id: number) => getRegionalService(negocio_id)

export const GetEmpresasByRegionales = (regionales: number[], organizaciones: number[]) =>
    Axios.get(`${server.host!}8014/api/v1/empresa/by-regionales`, {
        params: {
            regionales: regionales.join(','),
            organizaciones: organizaciones.join(','),
        },
        headers: { Authorization: server.obtenerToken() },
    })

export const GetEmpresasByOrganizacion = (organizacion_id: number) =>
    Axios.get(
        `${server.host}${server.puerto_integracion_sap}/api/v1/organization/organizationCompany/${organizacion_id}`,
        { headers: { Authorization: server.obtenerToken() } }
    )

export const SubirArchivoRecurso = (file: File) => {
    const formData = new FormData()
    formData.append('archivo', file)

    return Axios.post(`${server.host!}8014/api/v1/files/upload`, formData, {
        headers: {
            Authorization: server.obtenerToken(),
            'Content-Type': 'multipart/form-data',
        },
    })
}